var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"retain-focus":false,"max-width":"400","persistent":""},model:{value:(_vm.getLoginShow),callback:function ($$v) {_vm.getLoginShow=$$v},expression:"getLoginShow"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }